/**
 * ProPlusIndex — iter87.199.75
 *
 * Anon vs authed router at the `/rivalry-pro` index. Signed-in Pro+
 * users see the existing hub; anonymous visitors see the marketing
 * landing page. Same URL either way — the operator ratified this
 * over `/rivalry-pro/landing` because a single canonical URL keeps
 * the sign-up funnel clean.
 */
import React from "react";
import { useAuth } from "@clerk/react";
import { Loader2 } from "lucide-react";
import ProPlusLanding from "./ProPlusLanding";
import RivalryProApp from "./RivalryProApp";

export default function ProPlusIndex() {
    const { isSignedIn, isLoaded } = useAuth();
    if (!isLoaded) {
        return (
            <div
                className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center"
                data-testid="pro-plus-index-loading"
            >
                <Loader2 className="w-6 h-6 animate-spin text-cyber" />
            </div>
        );
    }
    return isSignedIn ? <RivalryProApp /> : <ProPlusLanding />;
}
